"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryActivity = void 0;
var HistoryActivityList_1 = require("./HistoryActivityList");
// tslint:disable:variable-name
var HistoryActivity = /** @class */ (function () {
    function HistoryActivity(data) {
        this.id = data.id;
        this.name = data.name;
        this.title = data.title;
        this.description = data.description;
        this.image = data.image;
        this.activity_id = data.activity_id;
        this.num_points = data.num_points;
        this.base_num_points = data.base_num_points;
        this.category_id = data.category_id;
        this.category_name = data.category_name;
        this.type_id = data.type_id;
        this.type_name = data.type_name;
        this.activity_channel_id = data.activity_channel_id;
        this.activity_channel_name = data.activity_channel_name;
        this.freq_cap = data.freq_cap;
        this.freq_period_id = data.freq_period_id;
        this.freq_period_name = data.freq_period_name;
        this.freq_num_required_attempts = data.freq_num_required_attempts;
        this.redirect_url = data.redirect_url;
        this.points_on_click = data.points_on_click;
        this.action_tags = data.action_tags;
        this.date_awarded = data.date_awarded;
        this.date_created = data.date_created;
        this.extra_data = data.extra_data;
        this.base_extra_data = data.base_extra_data;
        this.public_title = data.public_title;
        this.public_description = data.public_description;
        this.date_start = data.date_start;
        this.date_end = data.date_end;
        this.min_tier_id = data.min_tier_id;
        this.is_hidden_by_tier = data.is_hidden_by_tier;
        this.is_locked_by_tier = data.is_locked_by_tier;
        this.show_as_locked_by_tier = data.show_as_locked_by_tier;
        this.dateAwarded = null;
        this.bonusPoints = null;
    }
    HistoryActivity.JsonToActivities = function (data) {
        var activityList = new HistoryActivityList_1.HistoryActivityList();
        data.forEach(function (activity) {
            if (activity.extra_data && activity.extra_data['pre_assigned']) {
                activity.extra_data['pre_assigned'] = activity.extra_data['pre_assigned'] === 'true';
            }
            activityList.push(HistoryActivity.JsonToActivity(activity));
        });
        return activityList.getDateStartSorted();
    };
    HistoryActivity.JsonToActivity = function (data) { return new HistoryActivity(data); };
    return HistoryActivity;
}());
exports.HistoryActivity = HistoryActivity;
//# sourceMappingURL=HistoryActivity.js.map